import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconUnderline: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"underline"} maskId="square-filled-radius-0-stroke-1-IconUnderline"><path d="M7 12.0345V3H6V12.0345C6 15.8025 8.61352 19 12 19C15.3865 19 18 15.8025 18 12.0345V3H17V12.0345C17 15.408 14.6886 18 12 18C9.31135 18 7 15.408 7 12.0345Z" fill="currentColor"/><path d="M19 21V20H5V21H19Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconUnderline;
